import { PROGRESS_CONSTANT } from 'constant/progress-const';
import { ProgressType } from 'pages/candidateDashboard/candidateDashboard.type';

export const basicInformation = [
  PROGRESS_CONSTANT.SIGNIN,
  PROGRESS_CONSTANT.BASIC_INFO
];
export const assessmentInformation = [
  PROGRESS_CONSTANT.ASSESSMENT,
  PROGRESS_CONSTANT.LOGIC
];
export const profileCompletion = [
  PROGRESS_CONSTANT.PERSONALITY,
  PROGRESS_CONSTANT.PROFILE
];
export const getHired = [
  PROGRESS_CONSTANT.SHORTLISTED,
  PROGRESS_CONSTANT.MATCH_FOUND,
  PROGRESS_CONSTANT.HIRED
];

export const steps = [
  { step: 1, value: basicInformation },
  { step: 2, value: assessmentInformation },
  { step: 3, value: profileCompletion },
  { step: 4, value: getHired }
];
export const getProgress = (
  step: number,
  progress: ProgressType | undefined
): number => {
  if (!progress) return 0;
  const stepData = steps.find(st => st.step === step);
  if (!stepData) return 0;
  const stepProgress = stepData.value.reduce(
    (acc, key) => acc + (progress[key] ? 100 / stepData.value.length : 0),
    0
  );
  return stepProgress;
};

export const getCurrentStep = (progress: ProgressType | undefined): string => {
  if (!progress) return '';
  const currentStep = steps.find(step =>
    step.value.some(info => !progress[info])
  );
  return currentStep?.value.find(info => !progress[info]) ?? '';
};
